<template>
  <div>
    <verifyCitizenID />
  </div>
</template>

<script>
import verifyCitizenID from "../../../components/adminComponent/rolemanagement/verifyCitizenID";
export default {
  name:'VerifyCityzenID',
  components:{
    verifyCitizenID
  }
};
</script>
